export const state = () => ({
  playerInfo: {
    curServer: {},
    curGameName: {}
  }
})

export const getters = {
  curServer: (state) => state.playerInfo.curServer,
  curGameName: (state) => state.playerInfo.curGameName
}

export const mutations = {
  setCurServer(state, curServer) {
    state.playerInfo.curServer = curServer
  },
  setCurGameName(state, curGameName) {
    state.playerInfo.curGameName = curGameName
  }
}

export const actions = {}
